on("focus", "[data-focus-end]", function (event) {
	const input = $(this);

	setTimeout(function () {
		const length = input.val().length;
		input.prop("selectionStart", length).prop("selectionEnd", length);
	}, 0);
});
